import { render, staticRenderFns } from "./aiguilles.vue?vue&type=template&id=0bb17929&"
import script from "./aiguilles.vue?vue&type=script&lang=js&"
export * from "./aiguilles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports